import { ComponentsOverrides, Theme } from '@mui/material/styles';

export default function MuiTextField(theme: Theme): {
  MuiTextField: {
    styleOverrides: ComponentsOverrides<Theme>['MuiTextField'];
  };
} {
  return {
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiInputLabel-root ': {
            lineHeight: '16px',
            color: theme.palette.mode === 'light' ? theme.palette.grey[500] : theme.palette.grey[100],
          },
          '& .MuiOutlinedInput-root': {
            padding: '12px 16px',
            minHeight: '48px',
            fontWeight: 400,
            backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[100] : theme.palette.grey[800],
            // Fieldset
            '&:hover fieldset': {
              borderColor: theme.palette.primary.light,
            },
            '&.Mui-focused fieldset': {
              borderColor: theme.palette.primary.main,
            },
            '&.Mui-disabled fieldset': {
              borderColor: theme.palette.grey[400],
            },

            '&.Mui-error fieldset': {
              borderColor: theme.palette.error.dark,
            },
            // MuiInputBase
            '.MuiInputBase-input': {
              color: theme.palette.mode === 'light' ? theme.palette.grey[800] : theme.palette.grey[100],
              padding: 0,
              fontSize: '16px',
              lineHeight: '24px',
              '&::placeholder': {
                textOverflow: 'ellipsis !important',
                color: 'text.disabled',
              },
            },
            '.MuiInputAdornment-root': {
              margin: '0 8px 0 0',
            },
          },
        },
      },
    },
  };
}
